export default {
  translation: {
    common: {
      emailOrUsername: 'Eメールまたはユーザー名',
      invalidEmailOrUsername: 'Eメールまたはユーザー名が無効',
      invalidPassword: 'パスワードが無効',
      noInternetConnection: 'インターネットに接続されていません',
      pageNotFound_title: 'ページが見つかりません',
      password: 'パスワード',
      projectManagement: 'プロジェクト管理',
      serverConnectionFailed: 'サーバーの接続に失敗',
      unknownError: '不明なエラーです。後でもう一度試してください。',
      useSingleSignOn: 'SSOを使用',
    },

    action: {
      logIn: 'ログイン',
      logInWithSSO: 'SSOでログイン',
    },
  },
};
